export default "__VITE_ASSET__398a04db__"